(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["cl-catalogo"] && !Shopify.designMode) return;
  try {
    
  (() => {
    // profundidad del banner al hacer scroll (Horizon desplaza dentro de .page-wrapper: scroll en captura)
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    let raf = 0;
    const mover = () => {
      raf = 0;
      document.querySelectorAll('[data-cl-catalogo] .cl-cat__banner').forEach((banner) => {
        const r = banner.getBoundingClientRect();
        if (r.bottom < 0 || r.top > innerHeight) return;
        banner.style.setProperty('--cl-scroll', Math.max(0, Math.min(1, -r.top / r.height)).toFixed(3));
      });
    };
    document.addEventListener('scroll', () => { if (!raf) raf = requestAnimationFrame(mover); }, { capture: true, passive: true });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cl-gateway"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const iniciar = (raiz) => {
      if (!raiz || raiz.dataset.clListo !== undefined) return;
      raiz.dataset.clListo = '';
      const reducido = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      const fino = window.matchMedia('(hover: hover) and (pointer: fine)').matches;

      raiz.querySelectorAll('[data-cl-puerta]').forEach((puerta) => {
        // recuerda el catalogo elegido (para atajos y para medir preferencia)
        puerta.addEventListener('click', () => {
          try { localStorage.setItem('coltienda_catalogo', puerta.dataset.clPuerta); } catch (e) {}
        });
        if (reducido || !fino) return;
        // profundidad: la foto sigue al cursor (max 14px), el texto va levemente al reves
        let raf = 0;
        puerta.addEventListener('pointermove', (ev) => {
          if (raf) return;
          raf = requestAnimationFrame(() => {
            raf = 0;
            const r = puerta.getBoundingClientRect();
            const x = (ev.clientX - r.left) / r.width - 0.5;
            const y = (ev.clientY - r.top) / r.height - 0.5;
            puerta.style.setProperty('--cl-mx', `${(-x * 28).toFixed(1)}px`);
            puerta.style.setProperty('--cl-my', `${(-y * 28).toFixed(1)}px`);
          });
        });
        puerta.addEventListener('pointerleave', () => {
          puerta.style.setProperty('--cl-mx', '0px');
          puerta.style.setProperty('--cl-my', '0px');
        });
      });
    };
    const todos = () => document.querySelectorAll('[data-cl-gateway]').forEach(iniciar);
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', todos);
    else todos();
    document.addEventListener('shopify:section:load', todos);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
